import { render, staticRenderFns } from "./TrainerDivisi.vue?vue&type=template&id=d50215b0&"
import script from "./TrainerDivisi.vue?vue&type=script&lang=js&"
export * from "./TrainerDivisi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrainerDivisi.vue"
export default component.exports